import React from 'react';
import PropTypes from 'prop-types';
import Scrollbars from "react-custom-scrollbars"
import ServiceHighlight from "./ServiceHighlight";
import ServiceDeliverables from "./ServiceDeliverables";
import ServiceDisciplines from "./ServiceDisciplines";
import Component from "../../components/Component"
import LoadingBanner from "../../components/LoadingBanner";
import ErrorBanner from "../../components/ErrorBanner";

const PYODetailTabs = {
    disciplines: 'Project Roles',
    highlight: 'Highlights',
    deliverables: 'Deliverables',
    // gantt: 'Example Gantt'
}

class ServiceOverviewSection extends Component {

    constructor(props) {
        super(props);

        let tabs = this.tabsForService(props.service);
        this.state = {
            ...this.state,
            tabs,
            activeTab: TB.first(tabs)
        }
    }

    tabsForService(service) {
        if (!service?.id) return [];
        let detailTabs = [];
        if (service?.disciplines?.length) {
            detailTabs.push('disciplines')
        }
        if (service?.highlight && service?.highlight?.length > 0) {
            detailTabs.push('highlight')
        }
        if (service?.phases?.length) {
            detailTabs.push('deliverables')
        }


        return detailTabs
    }

    renderHighlightTable(scrollable = false) {
        return (
            <ServiceHighlight
                scrollable={scrollable}
                highlight={this.props.service.highlight} />
        )
    }

    renderDeliverablesTable(scrollable = false) {

        return (
            <ServiceDeliverables
                key={"deliverables-table"}
                scrollable={scrollable}
                serviceId={this.props.service.id}
                phases={this.props.service.phases} />
        )
    }

    renderDisciplinesTable(scrollable = false) {
        return (
            <ServiceDisciplines
                scrollable={scrollable}
                disciplines={this.props.service.disciplines}
            />
        )
    }

    // renderDeliverableSchedule(scrollable = false) {
    //     return (
    //         <ServiceDeliverableSchedule
    //             scrollable={scrollable}
    //             service={this.props.service}
    //         />
    //     )
    // }

    renderTableForTab(tab, scrollable) {

        switch (tab) {
            case "highlight":
                return this.renderHighlightTable(scrollable);
            case "deliverables":
                return this.renderDeliverablesTable(scrollable);
            case "disciplines":
                return this.renderDisciplinesTable(scrollable)
            // case "gantt":
            //     return this.renderDeliverableSchedule(scrollable)
            default:
                return null;
        }
    }

    expandModal(tab) {
        let modal = {
            title: PYODetailTabs[tab],
            content: this.renderTableForTab(tab, false)
        };

        return TB.event("Modal@show", modal);
    }

    render() {
        let {
            tabs,
            activeTab
        } = this.state;

        let {
            error,
            onRetry,
            service,
            expandForModal
        } = this.props;

        if (!service?.id) return null;

        return TB.isObject(error) ? (
            <div style={{ marginTop: -50 }}>
                <ErrorBanner {...error} onRetry={onRetry} />
            </div>
        ) : (
            service?.phases ? (
                <div className={TB.mapClass("pyo-details", { "for-overview": expandForModal })}>
                    <div className="pyo-tabs">

                        {tabs.map(tab => (
                            <div key={"tab-pyo-" + tab}>
                                <button onClick={() => this.promisedState({ activeTab: tab })}
                                    className={TB.mapClass("btn btn-tab", {
                                        "active-tab": activeTab === tab
                                    })}>

                                    {PYODetailTabs[tab]}

                                </button>
                            </div>
                        ))}

                        {expandForModal && (
                            <div className="expand-pyo-detail">
                                <p onClick={() => this.expandModal(activeTab)}>
                                    EXPAND VIEW <i className="fas fa-expand" />
                                </p>
                            </div>
                        )}

                    </div>
                    <Scrollbars style={{ width: `100%`, height: 220 }}>
                        {
                            activeTab &&
                            service?.phases?.length > 0 &&
                            this.renderTableForTab(activeTab, expandForModal)
                        }
                    </Scrollbars>
                </div>
            ) : <LoadingBanner message={"Loading Service Details"} />
        )
    }
}

ServiceOverviewSection.propTypes = {
    expandForModal: PropTypes.any,
    service: PropTypes.any,
    onRetry: PropTypes.any,
    error: PropTypes.any,
};

export default ServiceOverviewSection;